import { render } from "./customers-main.vue?vue&type=template&id=c95354d4&scoped=true"
import script from "./customers-main.vue?vue&type=script&lang=js"
export * from "./customers-main.vue?vue&type=script&lang=js"

import "./customers-main.vue?vue&type=style&index=0&id=c95354d4&scoped=true&lang=css"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95354d4"]])

export default __exports__